import { FormProvider, SubmitHandler, useForm } from 'react-hook-form';
import { useTranslation } from 'react-i18next';
import { FormData, getLocalizedSchema } from './schema';
import { yupResolver } from '@hookform/resolvers/yup';
import { FormLayout } from '@expressable/syntax-ds';
import { FormUi } from './formUi';

type Props = {
  loading: boolean;
  onSubmit: SubmitHandler<FormData>;
  selfSignUp?: boolean;
  emailParam?: string;
};

export const NewPasswordForm = ({ loading, onSubmit, selfSignUp, emailParam }: Props): JSX.Element => {
  const { t } = useTranslation();
  const translationSuffix = selfSignUp ? '.fromSignUp' : '';

  const methods = useForm({
    mode: 'onSubmit',
    reValidateMode: 'onChange',
    resolver: yupResolver(getLocalizedSchema(t)),
    disabled: loading,
  });
  const { handleSubmit } = methods;

  return (
    <FormProvider {...methods}>
      <FormLayout onSubmit={handleSubmit(onSubmit)} className="max-w-[327px] mx-auto">
        <FormUi
          isLoading={loading}
          selfSignUp={selfSignUp}
          emailParam={emailParam}
          translationSuffix={translationSuffix}
        />
      </FormLayout>
    </FormProvider>
  );
};
